"use client";

import { useMediaQuery } from "@mantine/hooks";
import { ScrollView } from "react95";
import { BaddiesPage } from "@/components/partners/baddies/baddies-page";
import BaddiesMobilePage from "@/components/ui/baddies-mobile-page";

export default function Page() {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  return (
    <>
      {isSmallScreen === true && <BaddiesMobilePage disabled={false} />}
      {isSmallScreen === false && <BaddiesPage />}
    </>
  );
}
